import React, { useCallback, useState } from 'react';
import api from 'services';
import { useNewToast } from 'hooks/newToast';
import { appWarnings } from 'utils/appWarnings';

const SUCCESS = {
  type: 'success',
  message: '',
};

export const useCadDespolpador = () => {
  const { showToast } = useNewToast();

  const [despolpadores, setDespolpadores] = React.useState([]);

  const [deleteDespolpadorLoading, setDeleteDespolpadorLoading] = React.useState(false);
  const [addDespolpadorLoading, setAddDespolpadorLoading] = React.useState(false);
  const [despolpadoresLoading, setDespolpadoresLoading] = React.useState(false);
  const [editDespolpadorLoading, setEditDespolpadorLoading] = useState(false);

  const getDespolpadores = useCallback(async filter => {
    try {
      setDespolpadoresLoading(true);
      const response = await api.cadDespolpador().getDespolpadores(filter);
      setDespolpadores(response);
    } catch {
    } finally {
      setDespolpadoresLoading(false);
    }
  }, []);

  const addDespolpador = useCallback(
    async ({ descricao, codigo, tipo }) => {
      try {
        setAddDespolpadorLoading(true);
        const dados = {
          descricao,
          capacidade: 1,
          codigo: codigo?.codigo,
          tipo: tipo?.value,
        };
        const response = await api.cadDespolpador().addDespolpador(dados);
        showToast({ ...SUCCESS, message: `${tipo?.label} adicionado com sucesso!` });
        return response;
      } catch (err) {
        showToast(appWarnings.Danger(err));
        throw new Error(err);
      } finally {
        setAddDespolpadorLoading(false);
      }
    },
    [showToast]
  );

  const editDespolpador = useCallback(
    async ({ id, descricao, codigo, tipo }) => {
      try {
        setEditDespolpadorLoading(true);
        const dados = {
          descricao,
          capacidade: 1,
          codigo: codigo.codigo,
          tipo: tipo?.value,
        };
        await api.cadDespolpador().editDespolpador(id, dados);
        showToast({ ...SUCCESS, message: `${tipo?.label} editado com sucesso!` });
      } catch (err) {
        showToast(appWarnings.Danger(err));
        throw new Error(err);
      } finally {
        setEditDespolpadorLoading(false);
      }
    },
    [showToast]
  );

  const deleteDespolpador = useCallback(
    async id => {
      try {
        setDeleteDespolpadorLoading(true);
        await api.cadDespolpador().deleteDespolpador(id);
        showToast({
          type: 'success',
          message: 'Despolpador / lavador excluído com sucesso!',
        });
      } catch (err) {
        showToast(appWarnings.Danger(err));
        throw new Error(err);
      } finally {
        setDeleteDespolpadorLoading(false);
      }
    },
    [showToast]
  );

  return {
    getDespolpadores,
    despolpadores,
    addDespolpador,
    editDespolpador,
    deleteDespolpador,
    despolpadoresLoading,
    addDespolpadorLoading,
    editDespolpadorLoading,
    deleteDespolpadorLoading,
  };
};
